import { useLang } from "../../context/LanguageContext";
import { BUSINESS } from "../../lib/api";
import { MapPin, Mail, Phone } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#1C1917] px-4 sm:px-8 py-14 text-stone-300">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm">
            <h3 className="font-serif text-2xl text-white">{BUSINESS.name}</h3>
            <p className="mt-2 text-sm text-stone-400">{t("footer.tagline")}</p>
            <p className="mt-3 text-sm text-stone-300">{t("footer.hosts")}: <span className="font-semibold text-white">{BUSINESS.hosts}</span></p>
          </div>
          <div className="space-y-2 text-sm">
            <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#D9A05B]" /> {BUSINESS.addressArea}</p>
            <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 hover:text-white"><Mail className="h-4 w-4 text-[#D9A05B]" /> {BUSINESS.email}</a>
            <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4 text-[#D9A05B]" /> {BUSINESS.phoneDisplay}</a>
          </div>
        </div>
        <div className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-500">
          © {new Date().getFullYear()} {BUSINESS.name}. {t("footer.rights")} · {t("footer.madeWith")} ♥
        </div>
      </div>
    </footer>
  );
};
